import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { POSITION_POPUP_BEFORE_REGISTRATION } from '../reducers/upsells';
import UpsellsContainer from './UpsellsContainer';
import Button from '@s/Button';
import { transitionAfterCreateReservation } from '../../../actions/reservation';
import { setShowUpsellPopup } from '../actions/upsells';
import { createLoadingSelector } from '../../../selectors/helpers';
import { countCartedItemsForUpsell } from '../selectors/upsells';
import AlertContainer from '../../cart/containers/AlertContainer';
import KioskableComponent from '../../kiosk/KioskableComponent';
import KioskLayoutContainer from '../../kiosk/containers/KioskLayoutContainer'
import { isKioskMode, selectEventNameFromListingConfig } from '../../../selectors/ui';
import Translation from '@s/Translation';
import { TranslationContext } from 'checkout/config/Translations';

/**
 * TODO translate
 */
class UpsellPopup extends KioskableComponent {

    componentWillUnmount() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      })
    }

    continueToCheckout = () => {
        this.props.transitionAfterCreateReservation(this.props.token);
        this.props.setShowUpsellPopup(false);
    }

    hasSubmittedUpsell = () => {
        return this.props.countCartedUpsellItems > 0;
    }

    renderButton = () => {
        return (
            <div className={!this.props.isKiosk ? 'upsell-popup__footer' : 'kiosk-upsell-popup__header__action'}>
                <Button className={this.hasSubmittedUpsell() ? 'button--primary button--large checkout-form__button-submit' : 'button--clear checkout-form__button-back'} onClick={this.continueToCheckout} loading={this.props.loading}>
                    <Translation>{this.hasSubmittedUpsell() ? 'checkout__continue_to_checkout' : 'checkout__no_thanks'}</Translation>
                </Button>
            </div>
        );
    }

    renderOnline = () => {
        return (
            <TranslationContext.Consumer>
              {({ t }) => (
                <dialog
                  id="checkout-wrap"
                  className="checkout-wrap"
                  aria-modal="true"
                  aria-label={`${t('checkout__upsells_for_event', { event_name: this.props.eventName })}`}
                  tabIndex="-1"
                >
                    <div className="checkout checkout--upsell-popup">
                        <AlertContainer />
                        <div className="upsell--popup">
                            <div className="upsell-popup__body">
                                <UpsellsContainer
                                    position={POSITION_POPUP_BEFORE_REGISTRATION}
                                />
                            </div>
                            {this.renderButton()}
                        </div>
                    </div>
                </dialog>
              )}
            </TranslationContext.Consumer>
        );
    }

    renderKiosk = () => {
        return (
            <KioskLayoutContainer>
                <div className="kiosk__upsell--popup">
                    <div className="kiosk-upsell-popup__header">
                        <h3><Translation>{'checkout__add_to_order'}</Translation></h3>
                        {this.renderButton()}
                    </div>
                    <div className="kiosk-upsell-popup__content">
                        <UpsellsContainer
                            position={POSITION_POPUP_BEFORE_REGISTRATION}
                        />
                    </div>
                </div>
            </KioskLayoutContainer>
        );
    }
}

const getReservationLoading = createLoadingSelector(["RESERVATION_CREATE", "RESERVATION_FETCH"]);
const mapStateToProps = state => {
    return {
        token: state.reservation.token,
        eventName: selectEventNameFromListingConfig(state),
        countCartedUpsellItems: countCartedItemsForUpsell(null)(state),
        loading: !!getReservationLoading(state),
        isKiosk: isKioskMode(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        transitionAfterCreateReservation,
        setShowUpsellPopup,
    }, dispatch);
}

UpsellPopup.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(UpsellPopup)
